import React from 'react';

interface Props {
  id: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

class OverlayStdContainer extends React.Component<Props> {
  static defaultProps = {
    style: {},
  };

  render(): React.ReactNode {
    const { id, style } = this.props;
    return (
      <div
        id={id}
        className="pos-a column h100"
        style={{
          bottom: '0px',
          right: '0px',
          height: 'calc(100vh - 48px)',
          width: '477px',
          boxShadow: '0 2px 16px 0 rgba(0, 116, 204, 0.08)',
          borderRadius: '8px',
          overflow: 'hidden',
          backgroundColor: 'var(--light-grey-2)',
          ...style,
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default OverlayStdContainer;
